import { isFirebaseConfigured } from "@/auth/firebase";
import {
  googleSignInErrorMessage,
  resolvePostLoginPath,
  signInWithGoogle,
  subscribeAuth,
} from "@/auth/google-auth";

export function mountLoginPage(root: HTMLElement): () => void {
  root.className = "page-shell page-login";
  root.innerHTML = `
    <div class="login-stage" aria-hidden="true">
      <div class="login-stage__arena"></div>
      <div class="login-stage__tower"></div>
      <div class="login-stage__ki"></div>
      <div class="login-stage__scanlines"></div>
    </div>
    <main class="auth-card auth-command-panel" aria-labelledby="login-title">
      <p class="eyebrow login-eyebrow">Mind Survival</p>
      <h1 id="login-title" class="login-title">เข้าสู่ระบบ</h1>
      <p class="lede login-lede">ใช้บัญชี Google เพื่อบันทึกความคืบหน้าและเล่นต่อได้ทุกอุปกรณ์</p>
      <p id="login-error" class="form-error login-error" role="alert" hidden></p>
      <div class="login-google-bezel">
        <button type="button" id="google-sign-in" class="btn btn-google">
          <span class="btn-google-icon" aria-hidden="true">G</span>
          ลงชื่อเข้าใช้ด้วย Google
        </button>
      </div>
      <p id="login-config-hint" class="hint login-hint" hidden>
        ตั้งค่า <code>VITE_FIREBASE_API_KEY</code>, <code>VITE_FIREBASE_AUTH_DOMAIN</code>,
        และ <code>VITE_FIREBASE_PROJECT_ID</code> ใน <code>.env</code> (โฟลเดอร์โปรเจกต์)
      </p>
      <a class="text-link login-back" href="/">← กลับหน้าแรก</a>
    </main>
  `;

  const errorEl = root.querySelector<HTMLElement>("#login-error");
  const hintEl = root.querySelector<HTMLElement>("#login-config-hint");
  const button = root.querySelector<HTMLButtonElement>("#google-sign-in");

  const configured = isFirebaseConfigured();
  if (!configured) {
    hintEl?.removeAttribute("hidden");
    button?.setAttribute("disabled", "true");
  }

  const showError = (message: string) => {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  };

  const redirectAfterLogin = () => {
    window.location.assign(resolvePostLoginPath());
  };

  const unsubAuth = subscribeAuth((user) => {
    if (user) redirectAfterLogin();
  });

  const onSignIn = async () => {
    if (!button) return;
    button.disabled = true;
    errorEl?.setAttribute("hidden", "true");
    try {
      await signInWithGoogle();
      redirectAfterLogin();
    } catch (err) {
      showError(googleSignInErrorMessage(err));
      button.disabled = !configured;
    }
  };

  button?.addEventListener("click", () => {
    void onSignIn();
  });

  return () => {
    unsubAuth();
    button?.replaceWith(button.cloneNode(true));
  };
}
